import React, { useEffect, useState } from "react";
import RegisterPage, { inputfield } from "./RegisterPage";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
import GuestLoginValidateMPIN from "./GuestLoginValidateMPIN";
import { loginScreenState } from "../constant";
import TrialPeriod from "../TrialPeriod";
import GuestRegValidateOTP from "./guestRegValidateOTP";
import GuestSetMPIN from "./guestSetMPIN";
const GuestLogin = (props) => {
    const redirectUrlFromQueryParams = getQueryParameterName("redirectUrl");
    const [formData, setFormData] = useState(inputfield);
    const [guestLoginMpinPayload, setGuestLoginMpinPayload] = React.useState();
    const [screenState, setScreenState] = useState(loginScreenState.GUEST_LOGIN);
    const [forgetFlow, setforgetFlow] = React.useState(false);
    const [clientAccount, setClientAccount] = useState(false);
    const [askToRegister, setAskToRegister] = useState(false);
    const [apiCall, setAPIcall] = useState(false);
    const [loginButtonDisable, setLoginDisable] = React.useState(false);
    const navigate = useNavigate();
    const { data: getAccountDetails, loader: getAccountDetailsLoader, errorData: getAccountDetailsError, } = useSelector((state) => state.LoginFlow.getAccountDetails);
    const onSubmit = () => {
        setAskToRegister(false);
        setClientAccount(false);
        let payload = {
            crycd: "91",
            mob: formData.mobile,
        };
        di.login.getAccountDetails(payload);
        setAPIcall(true);
    };
    useEffect(() => {
        if (apiCall && !getAccountDetailsLoader && !getAccountDetailsError.isOpen) {
            if (!getAccountDetails.clientAccount &&
                !getAccountDetails.registeredGuestAccount &&
                !getAccountDetails.status) {
                setAskToRegister(true);
                setLoginDisable(true);
            }
            else if (getAccountDetails.clientAccount) {
                setClientAccount(true);
                setLoginDisable(true);
            }
            else if (getAccountDetails.registeredGuestAccount)
                setScreenState(loginScreenState.GUEST_LOGIN_MPIN);
            setGuestLoginMpinPayload({ mob: formData.mobile });
        }
        else if (!getAccountDetailsLoader && getAccountDetailsError.isOpen)
            setLoginDisable(true);
    }, [
        getAccountDetails,
        getAccountDetailsLoader,
        getAccountDetailsError,
        apiCall,
    ]);
    const handleScreenState = () => {
        switch (screenState) {
            case loginScreenState.GUEST_LOGIN:
                return (React.createElement(React.Fragment, null,
                    React.createElement(RegisterPage, { removeNameField: true, submit: onSubmit, parentStateVariable: setFormData, pageTitle: "Continue as Guest", disableSubmit: getAccountDetailsLoader, errorState: errorStateMessage(), loginButtonDisable: loginButtonDisable, setLoginDisable: setLoginDisable }),
                    clientAccount && apiCall && (React.createElement("div", { className: "DMSansNormal_12_400 txt-oslo_grey px-3 pb-4" },
                        "Please proceed to client\u00A0",
                        React.createElement(Link, { to: "/login" }, "login"))),
                    askToRegister && apiCall && (React.createElement("div", { className: "DMSansNormal_12_400 txt-oslo_grey d-flex justfy-content-center px-3 pb-4" },
                        "You are not registered.\u00A0\u00A0",
                        React.createElement(Link, { to: "/guest-register" }, "Please register first.")))));
            case loginScreenState.GUEST_LOGIN_MPIN:
                return (React.createElement(GuestLoginValidateMPIN, { guestLoginMpinPayload: guestLoginMpinPayload, redirectUrlFromQueryParams: redirectUrlFromQueryParams, setAfterLogin: props === null || props === void 0 ? void 0 : props.setAfterLogin, skipRedirectNavigation: props === null || props === void 0 ? void 0 : props.skipRedirectNavigation, setScreenState: setScreenState, setForgetFlow: setforgetFlow }));
            case loginScreenState.GUEST_LOGIN_TRIAL:
                return React.createElement(TrialPeriod, { setScreenState: setScreenState });
            case loginScreenState.GUEST_FORGOT_MPIN:
                return (React.createElement(GuestRegValidateOTP, { mob: guestLoginMpinPayload.mob, pageHeading: "Forgot PIN", previousPath: location.pathname, navigateTo: loginScreenState.GUEST_SET_MPIN, setScreenState: setScreenState }));
            case loginScreenState.GUEST_SET_MPIN:
                return (React.createElement(GuestSetMPIN, { setScreenState: setScreenState, navigateTo: () => props.setMainScreenState(loginScreenState.LOGIN), forgetFlow: forgetFlow, setForgetFlow: setforgetFlow }));
        }
    };
    useEffect(() => {
        handleScreenState();
    }, [screenState]);
    const errorStateMessage = () => {
        return (React.createElement(React.Fragment, null, getAccountDetailsError.isOpen && (React.createElement(ErrorExclamation, { errorMessage: getAccountDetailsError.error.getErrorMessageOrErrMsg() }))));
    };
    return (React.createElement(React.Fragment, null, handleScreenState()));
};
export default GuestLogin;
